import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import objectSupport from 'dayjs/plugin/objectSupport';

import { CURRENT_LOCALE, DEFAULT_LOCALE } from 'src/constants';
import { loadExtraLocale } from 'src/utils/load-extra-locale';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(objectSupport);

if (CURRENT_LOCALE !== DEFAULT_LOCALE) {
  loadExtraLocale(CURRENT_LOCALE);
}

export const DATE_FORMATS = {
  DAY: CURRENT_LOCALE === 'he' ? 'D ..' : '.. DD',
  DAY_MONTH: CURRENT_LOCALE === 'he' ? 'D MMMM' : 'MMM DD',
  DAY_YEAR: CURRENT_LOCALE === 'he' ? 'D .. YYYY' : '.. DD, YYYY',
  MONTH: CURRENT_LOCALE === 'he' ? 'MMMM' : 'MMM',
  MONTH_YEAR: CURRENT_LOCALE === 'he' ? 'MMMM YYYY' : 'MMM, YYYY',
  YEAR: 'YYYY',
  FULL_DATE: CURRENT_LOCALE === 'he' ? 'D MMMM YYYY' : 'MMM DD, YYYY',
};

export default dayjs;
